import { render, staticRenderFns } from "./IsSablonForm.vue?vue&type=template&id=330794cc"
import script from "./IsSablonForm.vue?vue&type=script&lang=ts"
export * from "./IsSablonForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports